import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { AutoSuggest, IAutoSuggest } from "jsl-ui/lib/ui/auto.suggest";
import { PublicController } from "../../ajax/PublicController";
import { SearchResultDTO } from "../../ajax/types/SearchResultDTO";
import { EventHandler } from "jsl-ui";

export interface ITaxonInfo {
    id?: number;
    name?: string;
}

export class SelectTaxonComponent implements IJSLComponent {

    public onChange = new EventHandler<ITaxonInfo>();

    private lastResponse: ITaxonInfo[];

    private autoSuggest: IAutoSuggest;

    public constructor(private selectedItem?: ITaxonInfo) {
    }

    // private selectedItem: any;

    public getSelected(): ITaxonInfo {
        return this.selectedItem;
    }

    public render(): IJSLVNode {
        return {
            tag: "div",
            children: [
                {
                    tag: "input", attr: { placeholder: "Taxon Name", class: "common-input mt-20 form-control", type: "text", blur: this.autoSelectEntry }
                }, {
                    tag: "div", content: this.selectedItem ? ("Taxon: " + this.selectedItem.name) : "", attr: { style: "font-style:italic; color:#999999;" }
                }]
        };
    }

    public onCreate(node: IJSLVNode) {
        const input = node.dom.querySelector("input");
        let xhr;
        this.autoSuggest = AutoSuggest(input, {
            source: (term, response) => {
                // tslint:disable-next-line: no-empty
                try { xhr.abort(); } catch (e) { }
                //xhr = $.getJSON("api/public/search/" + term, {}, (data) => { this.lastResponse = data; response(data); });
                const all = term.length > 3;
                xhr = PublicController.Search({ term, all }).then((data) => {
                    this.lastResponse = data; response(data);
                });
            },
            renderItem: (item: SearchResultDTO, search: string) => {
                return '<div class="autocomplete-suggestion" data-val="' + item.name + '" data-key="' + item.id + '">' + item.name + "</div>";
            },
            onSelect: (e, term, tag) => {
                const nummer = parseInt(tag.getAttribute("data-key"), 10);
                this.selectedItem = this.lastResponse.filter((x) => x.id === nummer)[0];
                this.onChange.notify(this.selectedItem);
                refresh();
            },
            cache: false
        });
        if (this.selectedItem != null) {
            input.setAttribute("data-key", (this.selectedItem.id ?? "").toString());
            input.value = this.selectedItem.name;
        }
    }

    public onRemove(node: IJSLVNode) {
        if (this.autoSuggest != null) {
            this.autoSuggest.destroy();
        }
    }

    private autoSelectEntry(evt: Event) {
        const val = (evt.currentTarget as HTMLInputElement).value.toLowerCase();
        let matches = this.lastResponse.filter((c) => c.name.toLowerCase().indexOf(val) >= 0);
        if (matches.length === 1) {
            this.selectedItem = matches[0];
        } else if (matches.length > 1) {
            matches = this.lastResponse.filter((c) => c.name.toLowerCase() === val);
            if (matches.length === 1) {
                this.selectedItem = matches[0];
            }
        }
    }

}
